import permissions from '../../access/permissions.json'

export default {
  [permissions.PROJECTS.WORKSPACE.PERMISSION]: [
    {
      title: 'Модуль "О Проекте"',
      description: `Основная функция: Управление описанием и представлением вашего проекта.
        Что можно сделать:
          Редактировать краткое описание проекта (основная информация).
          Редактировать полное описание проекта (детали, цели, особенности).
          Выбрать и настроить шаблон-лендинг: Используйте готовые шаблоны для создания привлекательной презентационной страницы вашего проекта.
        Важно: Функция шаблона-лендинга доступна только для проектов типов "Открытый" и "Закрытый".
        Нажмите "Далее" в этом модуле, чтобы узнать больше о редактировании описаний и работе с шаблонами.
      `,
    },
    {
      title: 'Модуль "Управление"',
      description: `Основная функция: Администрирование проекта и его функциональности.
        Что можно сделать:
          Управлять командой администраторов ("Моя команда"): Назначать или снимать права администратора для участников проекта.
          Управлять модулями проекта: Добавлять или удалять дополнительные функциональные модули (например, "Реестр", "Опросы", "ПланЛаб" и т.д.), расширяющие возможности проекта.
          Настраивать проект: Производить ключевые настройки проекта (например, тип проекта, видимость, доступ и другие параметры).
        Нажмите "Далее" в этом модуле, чтобы узнать больше о правах администраторов, доступных модулях и настройках проекта.
      `,
    },
    {
      title: 'Модуль "Участники"',
      description: `Основная функция: Управление членством в проекте.
        Что можно сделать:
          Просматривать список текущих участников проекта.
          Приглашать новых пользователей присоединиться к вашему проекту (поиск и отправка приглашений).
          Управлять заявками: Просматривать, принимать или отклонять заявки от пользователей, желающих вступить в проект.
        Нажмите "Далее" в этом модуле, чтобы получить детальную информацию о приглашениях и обработке заявок.
      `,
    },
  ],
}
